<main class="container">
    <section id="main">
        <div class="row slider-row flex-sm-wrap flex-md-nowrap">
            <div
                class="col col-3 sidebar-column"
                [class.collapsed]="isSidebarCollapsed"
            >
                <div class="filter-header" [class.hidden]="isSidebarCollapsed">
                    <div class="d-flex align-items-center justify-content-center">
                        <h5 class="m-0 me-1">filters</h5>
                        <button 
                            type="button" 
                            class="btn p-0 help-icon-btn"
                            [class.clicked]="helpClicked"
                            (click)="onHelpClick()"
                            title="Get help about IT Tooling Site"
                            aria-label="Help information"
                        >
                            <span class="material-symbols-outlined help-icon">help</span>
                        </button>
                    </div>
                </div>

                <form [formGroup]="searchTextFilter" [class.hidden]="isSidebarCollapsed" slot="search">
                    <div class="search-controls-container">
                        <div class="search-input-wrapper position-relative">
                            <button
                                type="button"
                                class="search-btn"
                                title="Search"
                                (click)="onSubmitSearch()"
                            >
                                <span class="material-symbols-outlined">search</span>
                            </button>
                            <input
                                class="search-input form-control"
                                type="text"
                                formControlName="textFilter"
                                placeholder="Search tools..."
                                (keyup.enter)="onSubmitSearch()"
                                (keyup.escape)="clearSearchInput()"
                            />
                            @if (textFilter?.value) {
                            <button
                                type="button"
                                class="clear-btn"
                                (click)="clearSearchInput()"
                                aria-label="Clear search"
                                title="Clear search"
                            >
                                <i class="icon icon-remove"></i>
                            </button>
                            }
                        </div>
                    </div>
                </form>
                <button
                    class="btn-filter-close"
                    [class.collapsed]="isSidebarCollapsed"
                    (click)="toggleSidebar()"
                    [attr.aria-expanded]="!isSidebarCollapsed"
                    aria-label="Toggle sidebar"
                >
                    <span class="material-symbols-outlined">
                        @if (!isSidebarCollapsed) {
                            keyboard_double_arrow_left
                        } @else {
                            keyboard_double_arrow_right
                        }
                    </span>
                </button>

                <div class="sidebar-content" [class.hidden]="isSidebarCollapsed">
                    <!-- TODO: Temporary hide persona selector -->
                    <!-- Persona Selector Component -->
                    <!-- <app-persona-selector></app-persona-selector> -->
                    <app-tools-sidebar-filter
                        [personas]="this.personas()"
                        [productTeams]="this.productTeams"
                        [lifeCyclePhases]="this.lifeCyclePhases"
                        [toolTypes]="this.toolTypes()"
                        (selectedFiltersChange)="onFilterValuesChange($event)"
                    ></app-tools-sidebar-filter>
                </div>
            </div>

            <div
                class="col col-9 content-column"
                [class.expanded]="isSidebarCollapsed"
            >
                <tools-data-view
                    [tools]="this.tools()"
                    [totalRecords]="this.totalCount()"
                    [currentPage]="this.currentPage()"
                    [isLoading]="this.isLoading()"
                    (pageChange)="onPageChange($event)"
                >
                </tools-data-view>
            </div>
        </div>
    </section>
</main>
